import React from 'react';
import { string, func, shape } from 'prop-types';
import classnames from 'classnames';
import { DatePicker, Form } from 'grab-ui';

import cssDatePicker from './date-picker-field.less';
import cssForm from '../form-field.less';

const FormItem = Form.Item;

const DatePickerField = ({
  id,
  label,
  placeholder,
  format,
  onChange,
  onOk,
  initialValue,
  disabledDate,
  form,
  dateRender,
  defaultPickerValue,
}) => {
  const { getFieldDecorator } = form;
  return (
    <FormItem
      label={label}
      className={classnames(cssForm.formItem, cssDatePicker.formItem)}
    >
      {getFieldDecorator(id, {
        initialValue,
      })(
        <DatePicker
          format={format}
          placeholder={placeholder}
          onChange={onChange}
          onOk={onOk}
          disabledDate={disabledDate}
          dateRender={dateRender || null}
          defaultPickerValue={defaultPickerValue}
        />,
      )}
    </FormItem>
  );
};

DatePickerField.propTypes = {
  id: string.isRequired,
  label: string.isRequired,
  placeholder: string,
  format: string.isRequired,
  onChange: func,
  onOk: func,
  initialValue: shape({}),
  disabledDate: func,
  form: shape({}).isRequired,
  dateRender: func,
  defaultPickerValue: shape({}),
};

DatePickerField.defaultProps = {
  onChange: undefined,
  onOk: undefined,
  initialValue: null,
  disabledDate: undefined,
  placeholder: '',
  dateRender: undefined,
  defaultPickerValue: null,
};

export default DatePickerField;
